import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts } from '../../../settings';
import { DelayLink } from '../../../components';

import './Card6.scss';

class Card6 extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Selic supera meta de disponibilidade - Iniciativas - {texts.title}</title>
        </Helmet>

        <div className="iniciativas-home card6-home page-gradient page-gradient--yellow bg-gray" ref="card6-home">
          <section className="iniciativas-area card6-area page--yellow">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink
                            to="/estrategias/para-o-mercado"
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title">Selic supera meta de disponibilidade</h1>
                        </div>
                        <div className="card__content__body">
                          <div className="row flex">
                            <div className="col-8">
                              <p>
                                Todos os esforços e investimentos em tecnologia garantiram a excelência do Selic
                                (Sistema Especial de Liquidação e de Custódia) em um ano repleto de desafios impostos
                                pela pandemia. O sistema do Banco Central que operacionalizamos há 41 anos, por meio de
                                uma parceria público-privada, encerrou 2020 com 99,9% de disponibilidade, acima da meta
                                estabelecida de 99,8%.
                              </p>
                              <p>
                                Para isso, desenvolvemos em 15 dias uma estrutura de tecnologia, com acessos remotos,
                                que possibilitasse que os mais de 120 funcionários conseguissem trabalhar com eficiência
                                de suas casas para manter funcionando aquele que é um dos pilares do Sistema Financeiro
                                Nacional.
                              </p>
                              <p>
                                Responsável pelo registro e liquidação dos títulos públicos, o sistema também calcula
                                diariamente a taxa Selic com base nessas operações. Em 2020, foram processados 1.540
                                leilões, com uma média de 25,5 mil operações por dia.
                              </p>
                            </div>
                            <div className="col-4 img-center h-img">
                              <img src={images.iniciativas.card6.img1} className="img1" />
                            </div>
                          </div>
                          <div className="col-12">
                            <p>
                              Além disso, o sistema atende o Banco Central em diversos projetos, cuja demanda é
                              intensificada em anos de crises econômicas, que exigem o desenvolvimento e o ajuste de
                              ferramentas para gerenciar a liquidez do mercado.
                            </p>
                            <p>
                              Ao longo do ano, também mantivemos projetos de melhorias operacionais, de eficiência e de
                              segurança do próprio sistema. A segurança cibernética, por exemplo, um dos nossos focos em
                              2019, foi intensificada em 2020 devido à migração da equipe para o home office. Fechamos o
                              ano concluindo todas as entregas planejadas, que somam 34 projetos. Entre eles,
                              destacam-se:
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-12 box-2">
                  <div className="row">
                    <div className="col-1 right">
                      <p>
                        <img src={images.iniciativas.card6.img2} className="card6-icons" />
                      </p>
                    </div>
                    <div className="col-11">
                      <p>
                        <b className="yellow">Plataforma de Pre-Matching</b>
                        <br />
                        Desenvolvida plataforma que faz o batimento (checagem das informações de compra e venda) das
                        operações com títulos públicos de forma automática, processo que até então era realizado por
                        e-mail ou telefone entre as casas que negociam o papel. Disponibilizada para testes em setembro,
                        a automatização de operações definitivas entrou para valer em dezembro. O acesso pode ser feito
                        por navegador de internet ou por API (Aplicação de Interface de Programas).
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-1 right">
                      <p>
                        <img src={images.iniciativas.card6.img3} className="card6-icons" />
                      </p>
                    </div>
                    <div className="col-11">
                      <p>
                        <b className="yellow">Pix</b>
                        <br />
                        Principal produto lançado pelo Banco Central em 2020, o Pix (Sistema de Pagamentos Instantâneos)
                        contou com o nosso apoio no desenvolvimento de um sistema que garantisse mecanismos de liquidez
                        aos participantes em finais de semana e feriados.
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-1 right">
                      <p>
                        <img src={images.iniciativas.card6.img4} className="card6-icons" />
                      </p>
                    </div>
                    <div className="col-11">
                      <p>
                        <b className="yellow">CPD em Brasília</b>
                        <br />
                        Foi concluído em janeiro de 2020 um projeto iniciado no ano anterior: transformar o backup do
                        Selic em Brasília em um completo centro de processamento de dados com capacidade de executar o
                        sistema. Localizado no prédio do BC na capital federal, o datacenter é o terceiro do Selic e
                        pode ser utilizado caso haja algum problema na cidade do Rio de Janeiro que indisponibilize os
                        outros dois centros da capital carioca.
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-1 right">
                      <p>
                        <img src={images.iniciativas.card6.img5} className="card6-icons" />
                      </p>
                    </div>
                    <div className="col-11">
                      <p>
                        <b className="yellow">Mudança no CPD do Rio de Janeiro</b>
                        <br />
                        Um dos centros de dados do Rio, que ficava há mais de 30 anos no prédio do BC, mudou de endereço
                        em 2020. A mudança trouxe mais robustez, estabilidade e disponibilidade para os serviços do
                        Selic: o novo datacenter possui a certificação Tier nível 3, que atesta a qualidade da
                        infraestrutura de CPDs. A migração foi concluída em outubro após um projeto de 11 meses, que foi
                        dividido em fases para que as informações tivessem sempre dois datacenters disponíveis para
                        processá-las.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { Card6 };
